import React, { forwardRef, useImperativeHandle, useState, useEffect, useCallback, useRef } from 'react';




import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { Card, CardContent } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


import Grid from '@material-ui/core/Grid';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import mini_icone_informacao from '../../assets/imgs/mini_icone_informacao.png';
import Cookies from 'js-cookie';
import { Box } from "@mui/material";
import TextField from '@material-ui/core/TextField';
import { useLocation } from 'react-router-dom';
import Draggable from "react-draggable";
import FolderIcon from '@mui/icons-material/Folder';

import Divider from '@mui/material/Divider';
import { Navigation, Pagination } from "swiper/modules"; // Certifique-se de importar os módulos


import miniatura_pdf from '../../assets/imgs/miniatura_pdf.png';

import api from '../../services/api';
import Typography from '@material-ui/core/Typography';
import { Button } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import {
    DialogActions,
    DialogContentText,
} from "@mui/material";
import {

    Link

} from "react-router-dom";

const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};

const AnexadorArquivos = forwardRef(({ flag, isOcorrencia, id, objeto, close,
isAtribuicao, isCombustivel, isAdvertencia,
}, ref) => {



    const [imagemSelecionada1, setImagemSelecionada1] = useState(null);
    const [imagemSelecionada2, setImagemSelecionada2] = useState(null);
    const [imagemSelecionada3, setImagemSelecionada3] = useState(null);
    const [imagemSelecionada4, setImagemSelecionada4] = useState(null);


    const [descricaoImagem1, setDescricaoImagem1] = useState('');
    const [descricaoImagem2, setDescricaoImagem2] = useState('');
    const [descricaoImagem3, setDescricaoImagem3] = useState('');
    const [descricaoImagem4, setDescricaoImagem4] = useState('');

 const [descricaoArquivo1, setDescricaoArquivo1] = useState('');
    const [descricaoArquivo2, setDescricaoArquivo2] = useState('');
    const [descricaoArquivo3, setDescricaoArquivo3] = useState('');


    
        const [arquivoSelecionado1, setArquivoSelecionado1] = useState(null);
        const [arquivoSelecionado2, setArquivoSelecionado2] = useState(null);
        const [arquivoSelecionado3, setArquivoSelecionado3] = useState(null);
    
    
        const onDropArquivo1 = useCallback((acceptedFiles) => {
            // Valida o tipo de arquivo
            if (!acceptedFiles[0].type.includes('application/pdf')) {
                alert('Apenas arquivos PDF são permitidos.');
                return;
            }
    
            // Processa o arquivo PNG
            setArquivoSelecionado1(acceptedFiles[0]);
    
        }, []);
    
        const onDropArquivo2 = useCallback((acceptedFiles) => {
            // Valida o tipo de arquivo
            if (!acceptedFiles[0].type.includes('application/pdf')) {
                alert('Apenas arquivos PDF são permitidos.');
                return;
            }
    
            // Processa o arquivo PNG
            setArquivoSelecionado2(acceptedFiles[0]);
        }, []);
    
        const onDropArquivo3 = useCallback((acceptedFiles) => {
            // Valida o tipo de arquivo
            if (!acceptedFiles[0].type.includes('application/pdf')) {
                alert('Apenas arquivos PDF são permitidos.');
                return;
            }
    
            // Processa o arquivo PNG
            setArquivoSelecionado3(acceptedFiles[0]);
        }, []);
    
    
    
        const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
            onDrop: onDropArquivo1,
            multiple: false, // Apenas um arquivo pode ser selecionado
            accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf
    
        });
        const { getRootProps: getRootArquivoProps2, getInputProps: getInputArquivoProps2 } = useDropzone({
            onDrop: onDropArquivo2,
            multiple: false, // Apenas um arquivo pode ser selecionado
            accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf
    
        });
        const { getRootProps: getRootArquivoProps3, getInputProps: getInputArquivoProps3 } = useDropzone({
            onDrop: onDropArquivo3,
            multiple: false, // Apenas um arquivo pode ser selecionado
            accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf
    
        });
    
    

    const [todasImagens, setTodasImagens] = useState([]);
    const [todosArquivos, setTodosArquivos] = useState([]);

    useEffect(() => {
        if (objeto) {
            const imagens = [];
            const arquivos = [];

            if (objeto.caminho_imagem1) {
                imagens.push({
                    caminho: objeto.caminho_imagem1.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_imagem1,

                });
            }

            if (objeto.caminho_imagem2) {
                imagens.push({
                    caminho: objeto.caminho_imagem2.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_imagem2,
                });
            }

            if (objeto.caminho_imagem3) {
                imagens.push({
                    caminho: objeto.caminho_imagem3.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_imagem3,
                });
            }

            if (objeto.caminho_imagem4) {
                imagens.push({
                    caminho: objeto.caminho_imagem4.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_imagem4,
                });
            }

            setTodasImagens(imagens);

            
            if (objeto.caminho_arquivo1) {
                arquivos.push({
                    caminho: objeto.caminho_arquivo1.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_arquivo1,

                });
            }

               if (objeto.caminho_arquivo2) {
                arquivos.push({
                    caminho: objeto.caminho_arquivo2.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_arquivo2,

                });
            }


                  if (objeto.caminho_arquivo3 ){
                arquivos.push({
                    caminho: objeto.caminho_arquivo3.replace(
                        "/home/wwgrup/documentacao/",
                        "https://gruporosinetos.com/documentacaomidias/"
                    ),
                    descricao: objeto.descricao_arquivo3,

                });
            }

            setTodosArquivos(arquivos);
        }
    }, [objeto]);








    async function salvarArquivos() {


        try {
            const formData = new FormData();


            formData.append('id', id);
            if (isOcorrencia)
                formData.append('ocorrencia', true);
            else if (isAdvertencia)
                formData.append('advertencia', true);
            else if (isAtribuicao)
                formData.append('atribuicao', true);
            else if (isCombustivel)
                formData.append('combustivel', true);

            formData.append('descricao_imagem1', descricaoImagem1);
            formData.append('descricao_imagem2', descricaoImagem2);
            formData.append('descricao_imagem3', descricaoImagem3);
            formData.append('descricao_imagem4', descricaoImagem4);


            // Adicionar as imagens ao FormData (só adiciona se existir)
            if (imagemSelecionada1) formData.append("imagens", imagemSelecionada1);
            if (imagemSelecionada2) formData.append("imagens", imagemSelecionada2);
            if (imagemSelecionada3) formData.append("imagens", imagemSelecionada3);
            if (imagemSelecionada4) formData.append("imagens", imagemSelecionada4);

                formData.append('descricao_arquivo1', descricaoArquivo1);
                        formData.append('descricao_arquivo2', descricaoArquivo2);
                        formData.append('descricao_arquivo3', descricaoArquivo3);

                             formData.append('arquivos', arquivoSelecionado1);
                                    formData.append('arquivos', arquivoSelecionado2);
                                    formData.append('arquivos', arquivoSelecionado3);

            const headers = {
                Authorization: "Bearer " + Cookies.get("token"),
            };
            const response = await api.post(
                "/v1/protected/documentacao/cadastrar",
                formData,
                { headers }
            );
            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                if (isOcorrencia) {
                    alert("Ocorrência Cadastrada!");

                } else if (isAdvertencia) {
                    alert("Advertência Cadastrada!");

                } else if (isCombustivel) {
                    alert("Gestão Cadastrada!");

                } else if (isAtribuicao) {
                    alert("Atribuição Cadastrada!");

                }

                close();
            }



        } catch (error) {
            if (error.response) {
                // erro vindo da API (4xx, 5xx)
                console.error("Erro na API:", error.response.data);
            } else if (error.request) {
                // requisição foi enviada mas sem resposta
                console.error("Sem resposta do servidor:", error.request);
            } else {
                // erro ao configurar a requisição
                console.error("Erro ao salvar arquivos:", error.message);
            }
            throw error; // relança o erro se quiser tratar no nível superior
        }
    }


    // expõe a função para o pai
    useImperativeHandle(ref, () => ({
        salvarArquivos
    }));




    const onDrop1 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada1(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop2 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada2(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop3 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada3(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);

    const onDrop4 = useCallback((acceptedFiles) => {
        // Obtém o arquivo recebido
        const file = acceptedFiles[0];
        if (!file) {
            alert("Nenhum arquivo recebido.");
            return;
        }

        // Converte a imagem para PNG usando Canvas
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;

                // Desenha a imagem no Canvas
                ctx.drawImage(img, 0, 0);

                // Converte o Canvas para PNG
                canvas.toBlob(
                    (blob) => {
                        const convertedFile = new File([blob], `${file.name.split('.')[0]}.png`, { type: "image/png" });
                        setImagemSelecionada4(convertedFile);
                        console.log("Imagem convertida para PNG:", convertedFile);
                    },
                    "image/png",
                    1 // Qualidade máxima
                );
            };
        };
        reader.readAsDataURL(file);
    }, []);



    const { getRootProps: getRootProps1, getInputProps: getInputProps1 } = useDropzone({
        onDrop: onDrop1,

        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });

    const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({
        onDrop: onDrop2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps3, getInputProps: getInputProps3 } = useDropzone({
        onDrop: onDrop3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });
    const { getRootProps: getRootProps4, getInputProps: getInputProps4 } = useDropzone({
        onDrop: onDrop4,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: 'image/*', // Restringe a aceitação apenas para arquivos .png
    });




    return (
        <Grid
            style={{ paddingTop: 5 }}
            container
            direction="row"
            item xs={12}
            alignItems="center"
            justifyContent="center"
            spacing={2}
        >


            {
                flag === 1 ?
                    (
                        <Grid container spacing={2}
                            item xs={12}
                            style={{ padding: 5 }}
                            rowSpacing={2}>


                            {todasImagens.length > 0 && (
                                <div style={{ textAlign: "center", width: "100%" }}>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={"auto"}
                                        navigation={true}
                                        pagination={{ clickable: true }}
                                        modules={[Navigation, Pagination]}
                                        style={{ width: "100%", maxWidth: "400px" }}
                                    >
                                        {todasImagens.map((imagem, index) => (
                                            <SwiperSlide key={index} style={{ textAlign: "center" }}>
                                                <a href={imagem.caminho} target="_blank" rel="noopener noreferrer">
                                                    <img
                                                        src={imagem.caminho}
                                                        alt={imagem.descricao}
                                                        style={{ width: "100%", height: "auto", borderRadius: "5px", cursor: "pointer" }}
                                                    />
                                                </a>
                                                <p>{imagem.descricao}</p>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )}

  <Grid container spacing={2}
                            item xs={12}
                            style={{ padding: 5 }}
                            rowSpacing={2}>
 {todasImagens.length > 0 && (
                                <div style={{ textAlign: "center", width: "100%" }}>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={"auto"}
                                        navigation={true}
                                        pagination={{ clickable: true }}
                                        modules={[Navigation, Pagination]}
                                        style={{ width: "100%", maxWidth: "400px" }}
                                    >
                                        {todosArquivos.map((imagem, index) => (
                                            <SwiperSlide key={index} style={{ textAlign: "center" }}>
                                                <a href={imagem.caminho} target="_blank" rel="noopener noreferrer">
                                                    <img
                                                        src={miniatura_pdf}
                                                        alt={imagem.descricao}
                                                        style={{ width: "100%", height: "auto", borderRadius: "5px", cursor: "pointer" }}
                                                    />
                                                </a>
                                                <p>{imagem.descricao}</p>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )}
  </Grid>
                          

                        </Grid>
                    )
                    :
                    (
                        <Grid item xs={12} style={{ padding: 40 }}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Grid item xs={3}>
                                <Card>
                                    <CardContent>
                                        {imagemSelecionada1 ? (
                                            <div style={{ textAlign: 'center' }}>
                                                <img
                                                    src={URL.createObjectURL(imagemSelecionada1)}
                                                    alt="Imagem Selecionada 1"
                                                    style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                />
                                                <button
                                                    style={{
                                                        backgroundColor: '#ff4d4f',
                                                        color: '#fff',
                                                        border: 'none',
                                                        padding: '10px 15px',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                        marginTop: '10px',
                                                    }}
                                                    onClick={() => setImagemSelecionada1(null)}
                                                >
                                                    Remover Imagem
                                                </button>
                                            </div>
                                        ) : (
                                            <div {...getRootProps1()} style={dropzoneStyles}>
                                                <input {...getInputProps1()} />
                                                <Typography align="center" variant="h5">
                                                    Arraste e solte uma imagem aqui ou clique para adicionar ou faça colagem
                                                </Typography>
                                            </div>
                                        )}
                                        <Grid item xs={12} style={{ padding: 40 }}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoImagem1"
                                                label="Descrição"
                                                required
                                                id="descricaoImagem21"
                                                value={descricaoImagem1}
                                                onChange={(e) => setDescricaoImagem1(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>


                            <Grid item xs={3}>
                                <Card>
                                    <CardContent>
                                        {imagemSelecionada2 ? (
                                            <div style={{ textAlign: 'center' }}>
                                                <img
                                                    src={URL.createObjectURL(imagemSelecionada2)}
                                                    alt="Imagem Selecionada 2"
                                                    style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                />
                                                <button
                                                    style={{
                                                        backgroundColor: '#ff4d4f',
                                                        color: '#fff',
                                                        border: 'none',
                                                        padding: '10px 15px',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                        marginTop: '10px',
                                                    }}
                                                    onClick={() => setImagemSelecionada2(null)}
                                                >
                                                    Remover Imagem
                                                </button>
                                            </div>
                                        ) : (
                                            <div {...getRootProps2()} style={dropzoneStyles}>
                                                <input {...getInputProps2()} />
                                                <Typography align="center" variant="h5">
                                                    Arraste e solte uma imagem aqui ou clique para adicionar ou faça colagem
                                                </Typography>
                                            </div>
                                        )}
                                        <Grid item xs={12} style={{ padding: 40 }}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoImagem2"
                                                label="Descrição"
                                                required
                                                id="descricaoImagem2"
                                                value={descricaoImagem2}
                                                onChange={(e) => setDescricaoImagem2(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={3}>
                                <Card>
                                    <CardContent>
                                        {imagemSelecionada3 ? (
                                            <div style={{ textAlign: 'center' }}>
                                                <img
                                                    src={URL.createObjectURL(imagemSelecionada3)}
                                                    alt="Imagem Selecionada 3"
                                                    style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                />
                                                <button
                                                    style={{
                                                        backgroundColor: '#ff4d4f',
                                                        color: '#fff',
                                                        border: 'none',
                                                        padding: '10px 15px',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                        marginTop: '10px',
                                                    }}
                                                    onClick={() => setImagemSelecionada3(null)}
                                                >
                                                    Remover Imagem
                                                </button>
                                            </div>
                                        ) : (
                                            <div {...getRootProps3()} style={dropzoneStyles}>
                                                <input {...getInputProps3()} />
                                                <Typography align="center" variant="h5">
                                                    Arraste e solte uma imagem aqui ou clique para adicionar ou faça colagem
                                                </Typography>
                                            </div>
                                        )}
                                        <Grid item xs={12} style={{ padding: 40 }}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoImagem3"
                                                label="Descrição"
                                                required
                                                id="descricaoImagem3"
                                                value={descricaoImagem3}
                                                onChange={(e) => setDescricaoImagem3(e.target.value)}

                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>


                            <Grid item xs={3}>
                                <Card>
                                    <CardContent>
                                        {imagemSelecionada4 ? (
                                            <div style={{ textAlign: 'center' }}>
                                                <img
                                                    src={URL.createObjectURL(imagemSelecionada4)}
                                                    alt="Imagem Selecionada 4"
                                                    style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
                                                />
                                                <button
                                                    style={{
                                                        backgroundColor: '#ff4d4f',
                                                        color: '#fff',
                                                        border: 'none',
                                                        padding: '10px 15px',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                        marginTop: '10px',
                                                    }}
                                                    onClick={() => setImagemSelecionada4(null)}
                                                >
                                                    Remover Imagem
                                                </button>
                                            </div>
                                        ) : (
                                            <div {...getRootProps4()} style={dropzoneStyles}>
                                                <input {...getInputProps4()} />
                                                <Typography align="center" variant="h5">
                                                    Arraste e solte uma imagem aqui ou clique para adicionar ou faça colagem
                                                </Typography>
                                            </div>
                                        )}
                                        <Grid item xs={12} style={{ padding: 40 }}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoImagem4"
                                                label="Descrição"
                                                required
                                                id="descricaoImagem4"
                                                value={descricaoImagem4}
                                                onChange={(e) => setDescricaoImagem4(e.target.value)}

                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>


                             <Grid
                             style={{ paddingTop: 5 }}
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                        >




                            <Grid item xs={12} style={{ padding: 5 }}
                                container
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Grid item xs={8}>
                                    <Card>
                                        <CardContent>
                                            {arquivoSelecionado1 ? (

                                                <div style={{ textAlign: 'center' }}>
                                                    <div
                                                        href={URL.createObjectURL(arquivoSelecionado1)}
                                                        onClick={() => window.open(URL.createObjectURL(arquivoSelecionado1), '_blank')}
                                                        onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado1))}
                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}
                                                    >
                                                        <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                                                    </div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <button
                                                            style={{
                                                                backgroundColor: '#ff4d4f',
                                                                color: '#fff',
                                                                border: 'none',
                                                                padding: '10px 15px',
                                                                borderRadius: '5px',
                                                                cursor: 'pointer',
                                                                marginTop: '10px',
                                                            }}
                                                            onClick={() => setArquivoSelecionado1(null)}
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                </div>


                                            ) : (
                                                <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                                    <input {...getInputArquivoProps1()} />
                                                    <Typography align="center" variant="h5">
                                                        Arraste e solte um arquivo aqui ou clique para adicionar
                                                    </Typography>
                                                </div>
                                            )}
                                            <Grid item xs={12} style={{ padding: 40 }}>
                                                <TextField
                                                    variant="standard"
                                                    name="descricaoArquivo1"
                                                    label="Descrição"
                                                    id="descricaoArquivo1"
                                                    value={descricaoArquivo1}
                                                    onChange={(e) => setDescricaoArquivo1(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                />
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={8}>
                                    <Card>
                                        <CardContent>
                                            {arquivoSelecionado2 ? (
                                                <div style={{ textAlign: 'center' }}>
                                                    <div
                                                        href={URL.createObjectURL(arquivoSelecionado2)}
                                                        onClick={() => window.open(URL.createObjectURL(arquivoSelecionado2), '_blank')}
                                                        onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado2))}
                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}
                                                    >
                                                        <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                                                    </div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <button
                                                            style={{
                                                                backgroundColor: '#ff4d4f',
                                                                color: '#fff',
                                                                border: 'none',
                                                                padding: '10px 15px',
                                                                borderRadius: '5px',
                                                                cursor: 'pointer',
                                                                marginTop: '10px',
                                                            }}
                                                            onClick={() => setArquivoSelecionado2(null)}
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div {...getRootArquivoProps2()} style={dropzoneStyles}>
                                                    <input {...getInputArquivoProps2()} />
                                                    <Typography align="center" variant="h5">
                                                        Arraste e solte um arquivo aqui ou clique para adicionar
                                                    </Typography>
                                                </div>
                                            )}
                                            <Grid item xs={12} style={{ padding: 40 }}>
                                                <TextField
                                                    variant="standard"
                                                    name="descricaoArquivo2"
                                                    label="Descrição"
                                                    id="descricaoArquivo2"
                                                    value={descricaoArquivo2}
                                                    onChange={(e) => setDescricaoArquivo2(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                />
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={8}>
                                    <Card>
                                        <CardContent>
                                            {arquivoSelecionado3 ? (
                                                <div style={{ textAlign: 'center' }}>
                                                    <div
                                                        href={URL.createObjectURL(arquivoSelecionado3)}
                                                        onClick={() => window.open(URL.createObjectURL(arquivoSelecionado1), '_blank')}
                                                        onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado3))}
                                                        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}
                                                    >
                                                        <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                                                    </div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <button
                                                            style={{
                                                                backgroundColor: '#ff4d4f',
                                                                color: '#fff',
                                                                border: 'none',
                                                                padding: '10px 15px',
                                                                borderRadius: '5px',
                                                                cursor: 'pointer',
                                                                marginTop: '10px',
                                                            }}
                                                            onClick={() => setArquivoSelecionado3(null)}
                                                        >
                                                            Remover
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div {...getRootArquivoProps3()} style={dropzoneStyles}>
                                                    <input {...getInputArquivoProps3()} />
                                                    <Typography align="center" variant="h5">
                                                        Arraste e solte um arquivo aqui ou clique para adicionar
                                                    </Typography>
                                                </div>
                                            )}
                                            <Grid item xs={12} style={{ padding: 40 }}>
                                                <TextField
                                                    variant="standard"
                                                    name="descricaoArquivo3"
                                                    label="Descrição"
                                                    id="descricaoArquivo3"
                                                    value={descricaoArquivo3}
                                                    onChange={(e) => setDescricaoArquivo3(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                />
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </Grid>
                        </Grid>

                        </Grid>
                    )
            }





        </Grid>
    );
});

export default AnexadorArquivos;